// @ts-nocheck
// Greif UI Kit = stroke-request-page
import React from "react";

const BillingLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M11 18h2v-1h1q.424 0 .713-.288A.97.97 0 0 0 15 16v-3a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 12h-3v-1h4V9h-2V8h-2v1h-1a.97.97 0 0 0-.713.287A.97.97 0 0 0 9 10v3q0 .424.287.713Q9.576 14 10 14h3v1H9v2h2zm-5 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.824.588-1.412A1.93 1.93 0 0 1 6 2h8l6 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22zm0-2h12V8.85L13.15 4H6z"
            />
        </svg>
    );
};

export default React.memo(BillingLine);
